import { createSlice } from '@reduxjs/toolkit';

import { SidebarContent, SidebarState } from '@/shared/types/sidebar';

const initialState: SidebarState = { content: null };

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setSidebarContent: (state, action: { payload: SidebarContent }) => {
      state.content = action.payload;
      state.pinned = action.payload !== null;
      state.meta = undefined;
    },

    // Atomic open: set content + meta in a single dispatch so middleware and
    // store subscribers never observe an intermediate state with new content
    // but stale/missing meta.
    openSidebar: (
      state,
      action: { payload: { content: Exclude<SidebarContent, null>; meta?: Record<string, string> } }
    ) => {
      state.content = action.payload.content;
      state.pinned = true;
      state.meta = action.payload.meta;
    },

    setDefaultSidebar: (state, action: { payload: SidebarContent }) => {
      // Skip if content was explicitly set (e.g. from command palette before navigation).
      // Consumes the pin so subsequent page navigations apply their defaults normally.
      if (state.pinned) {
        state.pinned = false;
        return;
      }
      state.content = action.payload;
    },

    setSidebarMeta: (state, action: { payload: Record<string, string> | undefined }) => {
      state.meta = action.payload;
    },

    // Clears without recording a dismissal, which the middleware persists for every page.
    resetSidebar: (state) => {
      state.content = null;
      state.pinned = false;
      state.meta = undefined;
    },
  },
});

export const { setSidebarContent, openSidebar, setDefaultSidebar, setSidebarMeta, resetSidebar } =
  sidebarSlice.actions;

export default sidebarSlice.reducer;
